import { Value } from "@wojtekmaj/react-daterange-picker/dist/cjs/shared/types";
import { useManageTable } from "hooks";
import moment from "moment";
import { useState } from "react";

import {
  useGetDriversDeliveriesInfo,
  useGetDriversDeliveriesReport
} from "../apis";

const useDriversDeliveriesInfo = () => {
  const { searchValue, setSearchValue, debouncedSearch, sorting, setSorting } =
    useManageTable();

  const [dateRange, setDateRange] = useState<Value>(null);

  const requestParams = {
    search: debouncedSearch,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "ASC",
    from:
      Array.isArray(dateRange) && dateRange[0]
        ? moment(dateRange[0]).format("YYYY-MM-DD")
        : moment().subtract(10, "year").format("YYYY-MM-DD"),
    to:
      Array.isArray(dateRange) && dateRange[1]
        ? moment(dateRange[1]).format("YYYY-MM-DD")
        : moment().add(1, "year").format("YYYY-MM-DD")
  } as const;

  const { driversDeliveriesInfo, isLoading } =
    useGetDriversDeliveriesInfo(requestParams);

  const deliveriesReport = useGetDriversDeliveriesReport(
    requestParams,
    dateRange
  );

  return {
    search: searchValue,
    setSearch: setSearchValue,
    sorting,
    setSorting,
    dateRange,
    setDateRange,
    driversDeliveriesInfo,
    deliveriesReport,
    isLoading
  };
};

export default useDriversDeliveriesInfo;
